export default __webpack_public_path__ + "static/media/ILUSTRACIONES_14.d0cf98bb.png";